import React from 'react';

export default function Claim (props) {
  return (
    <span {...props} className={'button ' + props.className}>{props.children}</span>
  );
}



// WEBPACK FOOTER //
// ./src/ui/Buttons/Claim.jsx